class ReviewsPdpContainer extends HTMLElement {
  constructor() {
    super();

    this.observerIntersection = null;
  }

  connectedCallback() {
    this.observerIntersection = new IntersectionObserver(
      this.observationCallback.bind(this),
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    this.observerIntersection.observe(this);
  }

  disconnectedCallback() {
    if (this.observerIntersection) {
      this.observerIntersection.disconnect();
    }
  }

  observationCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.initOkendoReviews();
        observer.unobserve(entry.target);
      }
    });
  }


  initOkendoReviews() {
    const isOkendoWidgetInit = this.getAttribute('data-okendo-init');

    if (isOkendoWidgetInit === 'true') {
      console.info('Okendo Already initialzed');

      return null;
    }

    if (
      !window.okeWidgetApi &&
      typeof window.okeWidgetApi?.initWidget !== 'function'
    ) {
      console.warn('Okendo Widget API Missing');

      return null;
    }

    if (
      window.okeWidgetApi &&
      typeof window.okeWidgetApi.initWidget === 'function'
    ) {
      this.setAttribute('data-oke-widget', '');
      window.okeWidgetApi.initWidget(this, true);
      this.setAttribute('data-okendo-init', 'true');
      this.removeAttribute('data-oke-hidden');

      const reviewMissingMessageEle = document?.querySelectorAll(
        '.review-missing-message'
      );

      if (reviewMissingMessageEle) {
        reviewMissingMessageEle?.forEach((element) => {
          element.style.display = 'none';
        });
      }
    }
  }
}

if (!customElements.get('reviews-pdp-container')) {
  customElements.define('reviews-pdp-container', ReviewsPdpContainer);
} else {
  console.log('Custom element "reviews-pdp-container" is already defined.');
}
